function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module typing/inputcommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import ChangeBuffer from './utils/changebuffer';
/**
 * The input command. Used by the {@link module:typing/input~Input input feature} to handle typing.
 *
 * @extends module:core/command~Command
 */

var InputCommand = /*#__PURE__*/function (_Command) {
  _inherits(InputCommand, _Command);

  var _super = _createSuper(InputCommand);

  /**
   * Creates an instance of the command.
   *
   * @param {module:core/editor/editor~Editor} editor
   * @param {Number} undoStepSize The maximum number of atomic changes
   * which can be contained in one batch in the command buffer.
   */
  function InputCommand(editor, undoStepSize) {
    var _this;

    _classCallCheck(this, InputCommand);

    _this = _super.call(this, editor);
    /**
     * Typing's change buffer used to group subsequent changes into batches.
     *
     * @readonly
     * @private
     * @member {module:typing/utils/changebuffer~ChangeBuffer} #_buffer
     */

    _this._buffer = new ChangeBuffer(editor.model, undoStepSize);
    /**
     * Stores batches created by the input command. The batches are used to differentiate input batches from other batches using
     * {@link module:typing/input~Input#isInput} method.
     *
     * @type {WeakSet<module:engine/model/batch~Batch>}
     * @protected
     */

    _this._batches = new WeakSet();
    return _this;
  }
  /**
   * The current change buffer.
   *
   * @type {module:typing/utils/changebuffer~ChangeBuffer}
   */


  _createClass(InputCommand, [{
    key: "buffer",
    get: function get() {
      return this._buffer;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(InputCommand.prototype), "destroy", this).call(this);

      this._buffer.destroy();
    }
    /**
     * Executes the input command. It replaces the content within the given range with the given text.
     * Replacing is a two step process, first the content within the range is removed and then the new text is inserted
     * at the beginning of the range (which after the removal is a collapsed range).
     *
     * @fires execute
     * @param {Object} [options] The command options.
     * @param {String} [options.text=''] The text to be inserted.
     * @param {module:engine/model/range~Range} [options.range] The range in which the text is inserted. Defaults
     * to the first range in the current selection.
     * @param {module:engine/model/range~Range} [options.resultRange] The range where the selection
     * should be placed after the insertion. If not specified, the selection will be placed right after
     * the inserted text.
     */

  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var model = this.editor.model;
      var doc = model.document;
      var text = options.text || '';
      var textInsertions = text.length;
      var selection = options.range ? model.createSelection(options.range) : doc.selection;
      var resultRange = options.resultRange;
      model.enqueueChange(this._buffer.batch, function (writer) {
        _this2._buffer.lock(); // Store the batch as an 'input' batch for the Input.isInput( batch ) check.


        _this2._batches.add(_this2._buffer.batch);

        model.deleteContent(selection);

        if (text) {
          model.insertContent(writer.createText(text, doc.selection.getAttributes()), selection);
        }

        if (resultRange) {
          writer.setSelection(resultRange);
        } else if (!selection.is('documentSelection')) {
          writer.setSelection(selection);
        }

        _this2._buffer.unlock();

        _this2._buffer.input(textInsertions);
      });
    }
  }]);

  return InputCommand;
}(Command);

export { InputCommand as default };